const NoResults = () => (
  <div className="grui my-20 mx-10 items-center justify-center text-center">
    No results found
  </div>
)

export default NoResults
